export interface CmsPaperlessInstructionPanel {
  paperlessInstructionPanelBody: string;
  paperlessInstructionPanelTitle: string;
}
